module.exports = __webpack_public_path__ + "_/node_modules/@reverbdotcom/commons/design-system/icons/core/jpy-83e21dc1424d151e18aa5a090943bf25.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@reverbdotcom/commons/design-system/icons/core/jpy.svg
// module id = qX8Q
// module chunks = 24